import SellerMainPage from '@/components/Layout/Seller/SellerMainPage';

export const SellerMainPageWrapper = () => {
  return <SellerMainPage />;
};
